"use client";

import { motion, useReducedMotion } from "framer-motion";
export default function Philosophy() {
  const shouldReduceMotion = useReducedMotion();
  const baseTransition = shouldReduceMotion ? {
    duration: 0.2,
    ease: "easeOut" as const
  } : {
    duration: 0.7,
    ease: "easeOut" as const
  };
  const fadeUp = {
    hidden: shouldReduceMotion ? {
      opacity: 0
    } : {
      opacity: 0,
      y: 16
    },
    show: {
      opacity: 1,
      y: 0
    }
  };
  const items = [{
    key: "rule",
    delay: 0
  }, {
    key: "eyebrow",
    delay: 0.1
  }, {
    key: "headline",
    delay: 0.2
  }, {
    key: "paragraph",
    delay: 0.3
  }, {
    key: "signature",
    delay: 0.4
  }];
  return;
}